import React, { useState } from 'react';
import { Plus, Save, X, Package, DollarSign, Layers, Users, Check } from 'lucide-react';
export function AddProduct() {
  const [fulfillment, setFulfillment] = useState('NiishEngine Design Team');
  return <div className="max-w-4xl mx-auto space-y-8" data-id="element-52">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-53">
        <div className="flex items-center gap-4" data-id="element-54">
          <div className="p-3 bg-indigo-50 text-indigo-600 rounded-lg" data-id="element-55">
            <Package size={24} data-id="element-56" />
          </div>
          <div data-id="element-57">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-58">
              Create Custom Service
            </h1>
            <p className="text-sm text-gray-500 font-medium" data-id="element-59">
              Define your own partner services and fulfillment rules.
            </p>
          </div>
        </div>
        <div className="flex gap-3" data-id="element-60">
          <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-61">
            <Save size={18} data-id="element-62" />
            Save Product
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-63">
        <div className="md:col-span-2 space-y-6" data-id="element-64">
          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm space-y-6" data-id="element-65">
            <div className="space-y-2" data-id="element-66">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-67">
                Product Name
              </label>
              <input type="text" placeholder="e.g. Monthly SEO Audit" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-68" />
            </div>

            <div className="space-y-2" data-id="element-69">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-70">
                Description
              </label>
              <textarea placeholder="Describe the service value..." className="w-full h-32 p-4 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none resize-none" data-id="element-71" />
            </div>

            <div className="grid grid-cols-2 gap-6" data-id="element-72">
              <div className="space-y-2" data-id="element-73">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-74">
                  Retail Price
                </label>
                <div className="relative" data-id="element-75">
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 font-bold" data-id="element-76">
                    $
                  </span>
                  <input type="number" placeholder="0.00" className="w-full pl-8 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-77" />
                </div>
              </div>
              <div className="space-y-2" data-id="element-78">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-79">
                  Billing Cycle
                </label>
                <select className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none appearance-none" data-id="element-80">
                  <option data-id="element-81">One-time</option>
                  <option data-id="element-82">Monthly Recurring</option>
                  <option data-id="element-83">Annual Recurring</option>
                </select>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm space-y-6" data-id="element-84">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-85">
              Fulfillment Category
            </h3>
            <div className="grid grid-cols-2 gap-4" data-id="element-86">
              {[{
              id: 'NiishEngine Design Team',
              icon: Layers,
              desc: 'Automated fulfillment by NiishEngine experts.'
            }, {
              id: 'Partner Self-Fulfill',
              icon: Users,
              desc: 'You handle the delivery and support.'
            }].map(item => <button key={item.id} onClick={() => setFulfillment(item.id)} className={`p-4 rounded-lg border-2 text-left transition-all ${fulfillment === item.id ? 'border-indigo-600 bg-indigo-50/50' : 'border-gray-100 hover:border-gray-200'}`} data-id="element-87">
                  <div className="flex items-center justify-between mb-2" data-id="element-88">
                    <item.icon size={20} className={fulfillment === item.id ? 'text-indigo-600' : 'text-gray-400'} data-id="element-89" />
                    {fulfillment === item.id && <Check size={16} className="text-indigo-600" data-id="element-90" />}
                  </div>
                  <p className="text-sm font-bold text-slate-900" data-id="element-91">{item.id}</p>
                  <p className="text-[10px] text-gray-500 font-medium mt-1" data-id="element-92">
                    {item.desc}
                  </p>
                </button>)}
            </div>
          </div>
        </div>

        <div className="space-y-6" data-id="element-93">
          <div className="bg-slate-900 p-6 rounded-lg text-white space-y-4" data-id="element-94">
            <h3 className="text-sm font-bold" data-id="element-95">Profit Preview</h3>
            <div className="space-y-3" data-id="element-96">
              <div className="flex justify-between text-xs" data-id="element-97">
                <span className="text-slate-400" data-id="element-98">Retail Price</span>
                <span className="font-bold" data-id="element-99">$0.00</span>
              </div>
              <div className="flex justify-between text-xs" data-id="element-100">
                <span className="text-slate-400" data-id="element-101">NiishEngine Fee</span>
                <span className="font-bold text-red-400" data-id="element-102">-$0.00</span>
              </div>
              <div className="h-[1px] bg-slate-800" data-id="element-103"></div>
              <div className="flex justify-between text-sm" data-id="element-104">
                <span className="font-bold text-indigo-400" data-id="element-105">Your Profit</span>
                <span className="font-bold text-indigo-400" data-id="element-106">$0.00</span>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm space-y-4" data-id="element-107">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-108">Visibility</h3>
            <div className="flex items-center justify-between" data-id="element-109">
              <span className="text-xs font-medium text-gray-500" data-id="element-110">
                Publish to Storefront
              </span>
              <div className="w-10 h-5 bg-indigo-600 rounded-full relative" data-id="element-111">
                <div className="absolute right-1 top-1 w-3 h-3 bg-white rounded-full" data-id="element-112"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}